import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import Loader from '../../../utils/Loader'
import { fill_action } from '../../../actions/fillList_action';
import { get_userList_action, deleteUserList_action } from '../../../actions/security_action/user_action';
import { roleActionId, sessionExpireMessage, StatusActionId, tokenInavlidMessage } from '../../../utils/constants';
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast, } from 'react-toastify';
import Pagination from "../../../utils/pagination";
import moment from 'moment'
import { data } from 'jquery';
import Header from '../../../common_components/Header';
import Button from "react-bootstrap/Button";
class User extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            userList: [],
            roleId: '',
            roleList: [],
            userName: '',
            userEmail: '',
            StatusId: '',
            StatusList: [],
            StatusName: '',
            userId: '',
            show: false,
            currentPage: 1,
            isAccordionExpanded: false,
            RoleName: ''
        }

        this.userAdd = this.userAdd.bind(this)
        this.userUpdate = this.userUpdate.bind(this)
        this.updateItem = this.updateItem.bind(this)
    }

    componentDidMount() {
        this.getFillList(roleActionId, '')
        this.getFillList(StatusActionId, '')

        setTimeout(() => {
            {
                sessionStorage.getItem("roleId") == 4 ?
                    this.props.navigate('/checkList') :
                    <></>
            }
        }, 10);

        setTimeout(() => {
            this.getUserList()
        }, 200);
    }


    getFillList(value, userID) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(value, (userID == '' || userID == null) ? null : userID)
            .then((data) => {
                if (data.error != 1) {
                    if (value == roleActionId) {
                        this.setState({ roleList: data.data, isLoading: false })
                    }
                    if (value == StatusActionId) {
                        this.setState({ StatusList: data.data, isLoading: false })
                        console.log("StatusList", data.data)
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    handleDelete(id) {
        this.setState({ isLoading: true })
        this.props
            .deleteUserList_action(id)
            .then((data) => {
                if (data.error != 1) {
                    this.props.navigate('/user')
                    this.getUserList()
                    this.setState({ isLoading: false, show: false })
                    toast.success("Deleted SuccessFully!", {
                        position: "top-center",
                        theme: 'colored',
                        autoClose: 3000,
                        hideProgressBar: true,
                    })
                }
                else {
                    if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                          toast.error(data.msg, {
                            position:"top-center",
                            theme: "colored",
                            autoClose: 3000,
                            hideProgressBar: true,
                          });
                        }, 500);
                    }else{
                    this.setState({ isLoading: false })
                    toast.error(data.data, {
                        position: "top-center",
                        theme: 'colored',
                        autoClose: 3000,
                        hideProgressBar: true,
                    })
                }}
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getUserList() {
        const { userName, userEmail, roleId, StatusId } = this.state
        this.setState({ isLoading: true })
        console.log("StatusId", StatusId)
        this.props
            .get_userList_action(
                userName != '' && userName != null ? userName : null,
                userEmail != '' && userEmail != null ? userEmail : null,
                roleId[0] != '' && roleId[0] != 'Select' ? roleId[0] : null,
                StatusId != '' && StatusId != 'Select' ? StatusId : null
            )
            .then((data) => {
                if (data.error != 1) {

                    this.setState({ userList: data.data })
                    this.setState({ isLoading: false })
                }
                else {
                    if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                          toast.error(data.msg, {
                            position:"top-center",
                            theme: "colored",
                            autoClose: 3000,
                            hideProgressBar: true,
                          });
                        }, 500);
                    }else{
                    this.setState({ isLoading: false })
                    toast.error(data.data, {
                        position: "top-center",
                        theme: 'colored',
                        autoClose: 3000,
                        hideProgressBar: true,
                    })}
                }
            })
            .catch((e) => {
                console.log(e);
            });

        localStorage.setItem("userName", userName)
        localStorage.setItem("userEmail", userEmail)
        localStorage.setItem("roleId", roleId)
        localStorage.setItem("StatusId", StatusId == 'Select' ? 1 : StatusId)
    }


    clearValue() {
        this.setState({
            userName: '',
            userEmail: '',
            roleId: '',
            StatusId: '',
            StatusName: '',
            RoleName: ''
        })

        setTimeout(() => {
            this.getUserList()
        }, 200);
    }

    updateItem(item) {
        this.setState({ currentPage: item });
    }

    toggleModal(id) {
        const { show, employeeDeleteId } = this.state

        const confirmed = window.confirm(
            "Do you really want to delete this record?"
        );

        if (confirmed) {
            this.handleDelete(id)
        }
    }

    userAdd() {
        this.props.navigate('/userAU', { state: { userAdd: true, } })
    }

    userUpdate(userId) {
        this.props.navigate('/userAU', { state: { userUpdate: true, userID: userId } })
    }

    record(userList) {
        // const { userList } =this.state
        return (
            <table class="table table-bordered table-striped" id="dashboard-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Contact no</th>
                        <th>Designation</th>
                        <th>Role</th>
                        <th>Status</th>
                        <th class="text-right" style={{ width: "7.5%" }}>Action</th>
                    </tr>
                </thead>
                {
                    userList != '' && userList != null ? (
                        userList.map((data, i) => (
                            < tbody id="myTable">
                                <tr>
                                    <td>{data.Name}</td>
                                    <td>{data.Email}</td>
                                    <td>{data.Phone != null && data.Phone != ''? data.Phone : '-'}</td>
                                    <td>{data.Designation != null  && data.Designation != '' ? data.Designation : '-'}</td>
                                    <td>{data.RoleName}</td>
                                    <td>{data.StatusID == 1 ? "Active" : "Inactive"}</td>
                                    <td class="text-right">
                                        <a title="Edit" class="btn btn-sm" onClick={() => this.userUpdate(data.UserID)}><i class="fa fa-edit action_btn_table"></i></a>
                                        {data.StatusID == 1 ?
                                            <a title="Delete" class="btn btn-sm delete_record" onClick={() => this.toggleModal(data.UserID)} ><i class="fa fa-trash action_btn_table"></i></a>
                                            : <></>}
                                    </td>
                                </tr>
                            </tbody>

                        ))
                    ) : (<tr><td colSpan={6} className='text-center'>Record not found</td></tr>)
                }
            </table>
        )
    }

    role(e) {
        var newList = []
        console.log("item", e)
        newList.push(e.value.split(','))
        console.log("newList 1", newList[0])
        console.log("newList 2", newList[0][0])
        console.log("newList 3", newList[0][1])
        setTimeout(() => {
            this.setState({
                roleId: newList[0],
                RoleName: newList[0][1]
            })
        }, 200);
    }

    status(e) {
        const { StatusList } = this.state

        this.setState({ StatusId: e.target.value })
        if (e.target.value == 'Select') {
            this.setState({ StatusName: 'Select' })
        }
        else {
            StatusList.filter(item => {
                console.log("item", item)
                if (e.target.value == item['ID']) {
                    this.setState({ StatusName: item['Status'] })
                }
            })
        }

    }

    render() {
        const { isLoading, userList, roleId, roleList, userName, userEmail, StatusId, StatusList, show, currentPage, isAccordionExpanded, RoleName, StatusName } = this.state

        const recordsPerPage = 10
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        // Records to be displayed on the current page
        const currentRecords = userList.slice(indexOfFirstRecord, indexOfLastRecord)
        const nPages = Math.ceil(userList.length / recordsPerPage)

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    <>
                        <main id="main">
                            <Header data={[22]} />
                            <section style={{ marginTop: "115px" }}>
                                <div class="container-fluid">
                                    <div class="page-header">
                                        <h4 class="page-title">List of User</h4>
                                        <div onClick={() => this.userAdd()}>
                                            <a class="btn btn-primary btn-sm create_btn">
                                                <i class="fa fa-plus"></i> <span class="hidden-xs">Add User</span>
                                            </a>
                                        </div>
                                    </div>

                                    <div class="search_accordion search_card">
                                        <div class="panel-group" id="accordion">
                                            <div class="panel panel-default">
                                                <div
                                                    className="panel-heading accordion-toggle collapsed"
                                                    data-toggle="collapse"
                                                    data-parent="#accordion"
                                                    data-target="#collapseOne"
                                                    aria-expanded={isAccordionExpanded}
                                                    onClick={() =>
                                                        this.setState({
                                                            isAccordionExpanded: !isAccordionExpanded,
                                                        })
                                                    }
                                                >
                                                    <h4 class="panel-title">Search</h4>

                                                    <div class="searched_items">
                                                        <h5>Name : <span>{userName}</span></h5>
                                                        <h5>Email : <span>{userEmail}</span></h5>
                                                        <h5>Role : <span>{RoleName != 'Select' ? RoleName : null}</span></h5>
                                                        <h5>Status : <span>{StatusName != 'Select' ? StatusName : null}</span></h5>
                                                    </div>

                                                </div>
                                                <div
                                                    id="collapseOne"
                                                    className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                                                        }`}
                                                >
                                                    <div class="panel-body">
                                                        <div class="row mr_0">
                                                            <div class="col-md-2">
                                                                <div class="form-group">
                                                                    <label>Name</label>
                                                                    <input type="text" class="form-control search_form_control" placeholder="Enter Name"
                                                                        value={userName}
                                                                        onChange={(e) => this.setState({ userName: e.target.value })}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <div class="form-group">
                                                                    <label>Email</label>
                                                                    <input type="text" class="form-control search_form_control" placeholder="Enter Email"
                                                                        value={userEmail}
                                                                        onChange={(e) => this.setState({ userEmail: e.target.value })}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <div class="form-group">
                                                                    <label>Role</label>
                                                                    <select class="form-control"
                                                                        value={roleId}
                                                                        onChange={(e) => this.role(e.target)}>

                                                                        <option>Select</option>
                                                                        {roleList.length > 0 && roleList.map(item => (
                                                                            <option
                                                                                key={item.RoleID}
                                                                                value={[item.RoleID, item.RoleName]}
                                                                            >
                                                                                {item.RoleName}
                                                                            </option>
                                                                        ))}

                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <div class="form-group">
                                                                    <label>Status</label>
                                                                    <select class="form-control"
                                                                        value={StatusId}
                                                                        onChange={(e) => this.status(e)}>

                                                                        <option>Select</option>
                                                                        {StatusList.length > 0 && StatusList.map(item => (
                                                                            <option
                                                                                key={item.ID}
                                                                                value={item.ID}>
                                                                                {item.Status}
                                                                            </option>
                                                                        ))}

                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div class="">
                                                                <label>&nbsp;</label>
                                                                <a class="btn btn-primary search_btn"
                                                                    onClick={() => this.getUserList()}
                                                                >Search</a>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <label>&nbsp;</label>
                                                                <a class="btn btn-primary search_btn"
                                                                    onClick={() => this.clearValue()}
                                                                >Clear</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="custom_table d-flex">
                                        <div class="hack1">
                                            <div class="hack2">

                                                {this.record(currentRecords)}
                                                {userList.length > 0 ? <Pagination
                                                    nPages={nPages}
                                                    currentPage={currentPage}
                                                    setCurrentPage={this.updateItem} /> : <></>}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </section>

                        </main>

                    </>
                )
                }



                <ToastContainer />

                <Modal show={show} size="md">
                    <Modal.Header>
                        <Modal.Title>Confirm Delete</Modal.Title>
                        <span
                            onClick={() => this.setState({ show: !show })}
                            style={{ cursor: "pointer", fontWeight: "800" }}
                        >
                            X
                        </span>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="col-md-12">
                            <h3 className="pop_label">Do you really want to delete this record?</h3>
                        </div>

                    </Modal.Body>

                    <Modal.Footer style={{ padding: '5px 12px' }}>
                        <Button variant="success" onClick={() => this.handleDelete()}>Yes</Button>
                        <Button variant="secondary" onClick={() => this.setState({ show: !show })}>
                            No
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, get_userList_action, deleteUserList_action })(User));